import { useApp } from '@/hooks/use-app-context';

/**
 * Shown in place of a chart when the platform has no real data for it yet,
 * or when the stats could not be loaded. Never replaced by sample data.
 */
export function ChartUnavailable({ isLoading = false }: { isLoading?: boolean }) {
  const { language } = useApp();
  const label = isLoading
    ? language === 'fr' ? 'Chargement…' : 'Loading…'
    : language === 'fr' ? 'Données non disponibles' : 'Data not available';

  return (
    <div className="flex min-h-[200px] items-center justify-center rounded-2xl border border-dashed border-border/40 px-4 text-sm text-muted-foreground">
      {label}
    </div>
  );
}
